module.exports = __webpack_public_path__ + "img/connection3.34b0b848.png";